import * as React from 'react';

function SvgStar(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M17.75 21.329a.667.667 0 01-.392-.125L12 17.318l-5.36 3.886a.667.667 0 01-1.022-.754l2.09-6.19-5.417-3.715a.667.667 0 01.375-1.217h6.683l2.017-6.207a.667.667 0 011.268 0L14.65 9.33h6.683a.667.667 0 01.377 1.217l-5.42 3.712 2.09 6.19a.666.666 0 01-.63.88z" })));
}

export default SvgStar;
